__turbopack_context__.v({
  "groupTitle": "Top50Results-module-scss-module__nGPvba__groupTitle",
  "showAll": "Top50Results-module-scss-module__nGPvba__showAll",
});
